import React from 'react';
import { Star } from 'lucide-react';

const questions = [
  "How knowledgeable was the seller?",
  "Were the deadlines met?",
  "How was the quality of products delivered?",
  "Would you recommend this seller to other buyers?",
  "How quick the seller responded to your queries?",
  "Did the seller meet your expectations?",
];

const ReviewHistoryContainer = ({
  reviews,
  isMyReview = true,
  isProductReview = false,
  /** Per-question ratings: only for the buyer's own history on My Reviews — never on product, vendor, dashboard, or order views. */
  showRatingQuestions = false,
  /** Seller dashboard / Ratings & feedback: feedback received on your listings (buyer name + product). */
  sellerReceivedReview = false,
}) => {
  const renderStars = (score) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={16}
        fill={index < score ? "gold" : "none"}
        stroke="gold"
      />
    ));
  };

  const getTextForScore = (score) => {
    switch (score) {
      case 1: return "Very Unsatisfied";
      case 2: return "Unsatisfied";
      case 3: return "Neutral";
      case 4: return "Satisfactory";
      case 5: return "Very Satisfied";
      default: return "Not rated";
    }
  };

  return (
    <div>
      {reviews.map((review) => (
        <div key={review.id} className="myReviewsHistoryItem">
          <div className="myReviewsHistoryHeader">
            {sellerReceivedReview && (
              <>
                <img src={review.image} alt="" className="myReviewsHistoryImage" />
                <div className="myReviewsHistoryHeaderContent">
                  <h3 className="myReviewsHistoryTitle">{review.title}</h3>
                  <p className="myReviewsHistoryReviewerName text-lg font-medium mb-3">
                    Review from {review.reviewerName}
                  </p>
                  <div className="myReviewsHistoryRating">
                    {renderStars(Math.floor(review.overallRating))}
                    <span>{review.overallRating.toFixed(1)}</span>
                  </div>
                </div>
              </>
            )}
            {!sellerReceivedReview && !isProductReview && (
              <img src={review.image} alt={review.title} className="myReviewsHistoryImage" />
            )}
            {!sellerReceivedReview && !isProductReview && (
              <div className="myReviewsHistoryHeaderContent">
                <h3 className="myReviewsHistoryTitle">{review.title}</h3>
                {<p className="myReviewsHistorySellerName">By {review.sellerName}</p>}
                <div className="myReviewsHistoryRating">
                  {renderStars(Math.floor(review.overallRating))}
                  <span>{review.overallRating.toFixed(1)}</span>
                </div>
              </div>
            )}
            {!sellerReceivedReview && isProductReview && !isMyReview && (
              <div className="myReviewsHistoryHeaderContent">
                <p className="myReviewsHistoryReviewerName text-lg font-medium mb-3">
                  Reviewed by {review.reviewerName}
                </p>
                <div className="myReviewsHistoryRating">
                  {renderStars(Math.floor(review.overallRating))}
                  <span>{review.overallRating.toFixed(1)}</span>
                </div>
              </div>
            )}
            {!sellerReceivedReview && isProductReview && isMyReview && (
              <div className="myReviewsHistoryHeaderContent">
                <div className="myReviewsHistoryRating">
                  {renderStars(Math.floor(review.overallRating))}
                  <span>{review.overallRating.toFixed(1)}</span>
                </div>
              </div>
            )}
          </div>
          {showRatingQuestions &&
            questions.map((question, index) => (
              <div key={index} className="myReviewsHistoryRatingRow">
                <span>{question}</span>
                <div className="myReviewsHistoryStars">
                  {renderStars(review.ratings[index])}
                  <span>{getTextForScore(review.ratings[index])}</span>
                </div>
              </div>
            ))}
          <div className="myReviewsHistoryReviewText">
            <p>"{review.comment}"</p>
            {review.images && review.images.length > 0 && (
              <div className="myReviewsHistoryAttachedImages">
                {review.images.map((imgSrc, index) => (
                  <img key={index} src={imgSrc} alt={`Attached ${index + 1}`} />
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewHistoryContainer;